import keys from 'constants/keys'
import { NotificationActionDispatcher } from 'services/notifications/NotificationActionDispatcher'
import { normalizeNotification } from 'services/notifications/normalizeNotification'
import { markNotificationsSeen } from 'services/notifications/notificationsApi'
import { commentsResolver } from 'services/notifications/resolvers/commentsResolver'
import { postsResolver } from 'services/notifications/resolvers/postsResolver'
import { popsResolver } from 'services/notifications/resolvers/popsResolver'
import { serviceCallsResolver } from 'services/notifications/resolvers/serviceCallsResolver'
import { tasksResolver } from 'services/notifications/resolvers/tasksResolver'
import { INotificationActionHandler, INotificationResolver } from 'services/notifications/types'

const fallbackResolver: INotificationActionHandler = {
  id: 'fallback',
  service: '__fallback__',
  async resolve(notification) {
    if (notification.target?.route) {
      return { path: notification.target.route, replace: true }
    }
    return { path: keys.ROUTE_NAMES.NEWS_FEED, replace: true }
  },
}

// Add one handler per notification service here. The dispatcher scopes event_type lookup inside
// the service, so common event names like "created" or "updated" never collide across services.
export const notificationActionDispatcher = new NotificationActionDispatcher({
  handlers: [serviceCallsResolver, postsResolver, tasksResolver, commentsResolver, popsResolver],
  fallbackHandler: fallbackResolver,
  normalize: normalizeNotification,
  markSeen: (notification) => markNotificationsSeen({ seenKeys: [notification.chrono_key] }),
  warnOnDuplicateEvents: process.env.NODE_ENV === 'development',
})

export function getResolver(service: string): INotificationResolver {
  return notificationActionDispatcher.getHandlerForService(service)
}
